module.exports = __webpack_public_path__ + "4892be375380e2711f431a59e0139c5a.pdf";